import { Stack } from "@mui/material";
import { FlaskIcon } from "@phosphor-icons/react/dist/csr/Flask";
import { FlowArrowIcon } from "@phosphor-icons/react/dist/csr/FlowArrow";
import { StarIcon } from "@phosphor-icons/react/dist/csr/Star";

import { ClearThisFilter, FilterRow } from "./Common";

const PurposeFilters = ({
  selected,
  onClick,
  onClearThisFilter,
}: {
  selected: string;
  onClick: (purpose: string) => void;
  onClearThisFilter: () => void;
}) => {
  return (
    <Stack sx={{ gap: "12px" }}>
      <FilterRow
        value="backfill"
        onClick={onClick}
        text="Backfill"
        isSelected={selected === "backfill"}
        icon={<FlowArrowIcon size="24px" />}
      />
      <FilterRow
        value="production"
        onClick={onClick}
        text="Published"
        isSelected={selected === "production"}
        icon={<StarIcon size="24px" />}
      />
      <FilterRow
        value="proof"
        onClick={onClick}
        text="Test"
        isSelected={selected === "proof"}
        icon={<FlaskIcon size="24px" />}
      />
      {selected ? <ClearThisFilter onClick={onClearThisFilter} /> : null}
    </Stack>
  );
};

export { PurposeFilters };
